import {DISCRETIONARY_PROJECT_QUARTERS_LIST} from "./ptsConstants";

export function GetImplementationsPerQuarter(implementations) {
    let implementationsByQuarter = [];
    for (let quarter of DISCRETIONARY_PROJECT_QUARTERS_LIST) {
        implementationsByQuarter[quarter.id] = implementations.filter(w => w.implementationQuarter === quarter.id);
    }

    return implementationsByQuarter;
}